import { Card, CardOptions } from "./card";

export class NewsFeatureList extends Card {
  constructor(element: HTMLElement, options: CardOptions) {
    super(element, options);
  }
}

export default function newsFeatureListInit() {
  const newsFeatureListItem = document.querySelectorAll(
    ".news-feature-list"
  ) as NodeListOf<HTMLElement>;
  for (let i = 0; i < newsFeatureListItem.length; i++) {
    new NewsFeatureList(newsFeatureListItem[i], {
      clickable: true,
      ctaClass: "news-feature-list__title a",
    });
  }
}
